function bindQuizButtons() {
  document.querySelectorAll('.pw-quiz-btn').forEach(function(btn) {
    if (!btn.dataset.bound) {
      btn.addEventListener('click', function() {
        var el = document.getElementById('pwQuiz');
        if (!el) {
          el = document.createElement('div');
          el.id = 'pwQuiz';
          el.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:2147483647;background:#fff';

          var close = document.createElement('div');
          close.style.cssText = 'position:absolute;top:12px;right:16px;z-index:2;background:#fff;width:44px;height:44px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:24px;color:#333;border-radius:50%;box-shadow:0 2px 8px rgba(0,0,0,0.12)';
          close.textContent = '✕';
          close.addEventListener('click', function() {
            el.style.display = 'none';
            document.body.classList.remove('pw-quiz-open');
          });

          var iframe = document.createElement('iframe');
          iframe.src = 'https://yourform-three.vercel.app/quiz/';
          iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:none';

          el.appendChild(close);
          el.appendChild(iframe);
          document.body.appendChild(el);
        }
        el.style.display = 'block';
        document.body.classList.add('pw-quiz-open');
      });
      btn.dataset.bound = 'true';
    }
  });
}

// Try immediately and on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindQuizButtons);
} else {
  bindQuizButtons();
}

// Also watch for dynamically added quiz buttons
if (window.MutationObserver) {
  new MutationObserver(bindQuizButtons).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// PelicanWork Desk Configurator — Shopify Embed
// Add to: Shopify Admin → Online Store → Themes → Edit Code → Assets → custom.js
// Or paste in theme.liquid before </body>
//
// Usage: Add button with class "pw-configure-btn" and data-slug attribute
//   <button class="pw-configure-btn" data-slug="model-207">Customize in 3D</button>

(function() {
  var CONFIGURATOR_URL = 'https://table-top-configurator.vercel.app';

  // Widget selectors to hide/remove when configurator is open
  var WIDGET_SELECTORS = [
    '#floating-button',
    '.pw-phone-float',
    '.yotpo-reviews-tab-floating-tab',
    '#google-merchantwidget-iframe-wrapper',
    '#merchantwidgetiframe',
    'google-reviews-badge',
    '.google-reviews-badge',
    '[class*="google-top-quality"]',
    '.float-mv-button',
    '[jslog*="merchantverse"]',
    'img[src*="top_quality_store"]',
    '#delightchat-widget',
    '#tidio-chat', '[id*="tidio"]', '[class*="tidio"]',
    '[id*="gorgias"]', '[class*="gorgias"]',
    '[class*="omnisend"]', '[id*="omnisend"]',
    'iframe[title*="chat"]',
    '[class*="chat-widget"]', '[id*="chat-widget"]',
    'loading-bar',
  ];

  // Inject CSS
  var style = document.createElement('style');
  style.textContent =
    // Button styling — black gradient sweep (matches the Model 304 snippet
    // the merchant ships inline on product pages). 10px radius, 15px label.
    '.pw-configure-btn{width:100%;padding:16px 24px;margin-top:12px;background:linear-gradient(135deg,#2a2a2a,#555,#2a2a2a);background-size:200% 200%;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;display:flex;align-items:center;justify-content:center;gap:10px;box-shadow:0 2px 8px rgba(0,0,0,0.15);transition:transform 0.2s,box-shadow 0.2s;-webkit-tap-highlight-color:transparent;animation:pw-glow-sweep 4s ease-in-out infinite}' +
    '.pw-configure-btn:hover{transform:translateY(-1px);box-shadow:0 4px 12px rgba(0,0,0,0.2)}' +
    '@keyframes pw-glow-sweep{0%{background-position:100% 50%}100%{background-position:-100% 50%}}' +
    // When open: lock viewport, fix position, hide everything except overlay
    'html.pw-configurator-open,body.pw-configurator-open{overflow:hidden!important;position:fixed!important;width:100%!important;height:100%!important;top:0!important;left:0!important}' +
    'body.pw-configurator-open>*:not(#pwConfigurator){display:none!important}' +
    'body.pw-configurator-open>#pwConfigurator{display:block!important;position:fixed!important;top:0!important;left:0!important;width:100vw!important;height:100vh!important;height:100dvh!important}';
  document.head.appendChild(style);

  var overlay = null;
  var iframe = null;
  var observer = null;

  function removeWidgets() {
    WIDGET_SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) { el.remove(); });
    });
  }

  function open(slug) {
    if (!overlay) {
      // Create overlay
      overlay = document.createElement('div');
      overlay.id = 'pwConfigurator';
      overlay.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100vw;height:100vh;height:100dvh;z-index:2147483647;background:#fff';

      // Loading spinner
      var loader = document.createElement('div');
      loader.id = 'pw-loader';
      loader.style.cssText = 'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:#fff;z-index:1;transition:opacity 0.3s';
      loader.innerHTML = '<div style="text-align:center">' +
        '<div style="width:32px;height:32px;border:3px solid #e0e0e0;border-top-color:#266de8;border-radius:50%;animation:pw-spin 0.8s linear infinite;margin:0 auto 12px"></div>' +
        '<p style="color:#999;font-size:13px;font-family:-apple-system,sans-serif">Loading configurator...</p></div>';
      overlay.appendChild(loader);

      // Spinner animation
      var spinStyle = document.createElement('style');
      spinStyle.textContent = '@keyframes pw-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(spinStyle);

      // Close button
      var close = document.createElement('div');
      close.style.cssText = 'position:absolute;top:12px;right:16px;z-index:2;background:rgba(0,0,0,0.06);width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:50%;transition:background 0.2s';
      close.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      close.onmouseover = function() { close.style.background = 'rgba(0,0,0,0.12)'; };
      close.onmouseout = function() { close.style.background = 'rgba(0,0,0,0.06)'; };
      close.onclick = function() { closeOverlay(); };

      // Iframe
      iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:none';
      iframe.allow = 'clipboard-write';

      overlay.appendChild(close);
      overlay.appendChild(iframe);
      document.body.appendChild(overlay);

      // Listen for messages
      window.addEventListener('message', handleMessage);
    }

    sessionEnd();
    sessionStart(slug);

    // Show loader, reset for new load
    var loader = document.getElementById('pw-loader');
    if (loader) { loader.style.display = 'flex'; loader.style.opacity = '1'; }

    // Set/update iframe src
    iframe.src = CONFIGURATOR_URL + '/configure/' + slug;

    // Show
    overlay.style.display = 'block';
    document.documentElement.classList.add('pw-configurator-open');
    document.body.classList.add('pw-configurator-open');

    // CSS handles widget hiding via .pw-configurator-open class
    // No need to remove widgets from DOM — they come back on close
  }

  function closeOverlay() {
    sessionEnd();
    if (overlay) overlay.style.display = 'none';
    document.documentElement.classList.remove('pw-configurator-open');
    document.body.classList.remove('pw-configurator-open');
    if (observer) { observer.disconnect(); observer = null; }
  }

  // Custom storefront event. Shopify.analytics.publish reaches Customer events pixels
  // (Settings → Customer events → subscribe with analytics.subscribe('configurator_opened', ...));
  // dataLayer is pushed too so a GTM container sees the same events.
  function track(name, data) {
    data = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data);
      }
      if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data));
    } catch (err) {
      console.warn('[PelicanWork] track failed:', err);
    }
  }

  // One configurator_session event per open→close (or page leave): seconds the page was
  // visible with the configurator open, excluding time the tab was in the background.
  var session = null;

  function sessionStart(slug) {
    session = { slug: slug, ms: 0, since: document.hidden ? null : Date.now(), interacted: false };
  }

  function sessionTick() {
    if (session && session.since) { session.ms += Date.now() - session.since; session.since = null; }
  }

  function sessionEnd() {
    if (!session) return;
    sessionTick();
    var s = session;
    session = null;
    if (s.ms < 1000) return;
    track('configurator_session', { slug: s.slug, seconds: Math.round(s.ms / 1000), interacted: s.interacted });
  }

  document.addEventListener('visibilitychange', function() {
    if (!session) return;
    if (document.hidden) sessionTick(); else session.since = Date.now();
  });
  window.addEventListener('pagehide', sessionEnd);

  function handleMessage(e) {
    console.log('[PelicanWork] Message received:', e.origin, e.data?.type);

    if (!e.data) return;

    // Accept messages from configurator domain or same origin
    if (!e.origin.includes('table-top-configurator.vercel.app') && e.origin !== window.location.origin) {
      console.warn('[PelicanWork] Origin rejected:', e.origin);
      return;
    }

    var type = e.data.type;
    var payload = e.data.payload;

    if (type === 'configurator:ready') {
      track('configurator_opened', { slug: (payload && payload.slug) || e.data.slug });
      // Hide loading spinner
      var loader = document.getElementById('pw-loader');
      if (loader) { loader.style.opacity = '0'; setTimeout(function() { loader.style.display = 'none'; }, 300); }
      // Send parent URL for QR code
      iframe.contentWindow.postMessage(
        { type: 'shopify:parent-url', payload: { url: window.location.href } },
        CONFIGURATOR_URL
      );
    }
    if (type === 'configurator:track' && payload && payload.event === 'interacted') {
      if (session) session.interacted = true;
      track('configurator_interacted', { slug: payload.slug, what: payload.what });
    }
    if (type === 'configurator:add-to-cart') {
      track('configurator_add_to_cart', {
        slug: payload.slug,
        price: payload.price,
        size: payload.config ? payload.config.w + 'x' + payload.config.d : '',
        accessories: (payload.accessories || []).length,
      });
      addToCart(payload);
    }
    if (type === 'configurator:save') {
      track('configurator_saved', { slug: payload.slug, price: payload.price });
      iframe.contentWindow.postMessage(
        { type: 'shopify:save-acknowledged', payload: { success: true } },
        CONFIGURATOR_URL
      );
    }
    if (type === 'configurator:close') {
      closeOverlay();
    }
    if (type === 'configurator:view-cart') {
      window.location.href = '/cart';
    }
  }

  function formatGrommetEntry(g) {
    var shapeLabel = g.shape === 'oblong' ? 'Oblong' : 'Circle';
    var dims = g.shape === 'oblong' ? (g.w + 'x' + g.d + 'mm') : (g.w + 'mm');
    return shapeLabel + ' ' + dims + ' at ' + g.fromRight + 'mm from right, ' + g.fromRear + 'mm from back';
  }

  function formatGrommetsProperty(grommetPositions) {
    if (!grommetPositions || grommetPositions.length === 0) return null;
    return grommetPositions.map(formatGrommetEntry).join('; ');
  }

  // Merge a "Controller Position: Left/Right" line into the cart's existing
  // note without clobbering anything else a customer typed there (e.g. a
  // gift message). Strips any prior Controller Position line first so
  // reopening the configurator and re-adding doesn't pile up duplicates.
  function buildCartNote(existingNote, controllerPositionLabel) {
    var lines = (existingNote || '').split('\n').filter(function(line) {
      return line.indexOf('Controller Position:') !== 0;
    });
    if (controllerPositionLabel) lines.push('Controller Position: ' + controllerPositionLabel);
    return lines.join('\n').trim();
  }

  function addToCart(payload) {
    var items = [];
    var deskProperties = {
      'Configuration': (payload.config ? payload.config.w + 'x' + payload.config.d + 'mm' : ''),
      'Configurator Price': '₹' + Number(payload.price).toLocaleString('en-IN'),
      'Configurator Slug': payload.slug,
    };
    var grommetsProperty = formatGrommetsProperty(payload.grommetPositions);
    if (grommetsProperty) deskProperties['Grommets'] = grommetsProperty;

    if (payload.shopifyCartItems && payload.shopifyCartItems.length > 0) {
      var deskItem = payload.shopifyCartItems[0];
      if (deskItem.properties) {
        for (var key in deskItem.properties) {
          if (Object.prototype.hasOwnProperty.call(deskItem.properties, key)) {
            deskProperties[key] = deskItem.properties[key];
          }
        }
      }
      items.push({
        id: deskItem.variantId,
        quantity: deskItem.quantity || 1,
        properties: deskProperties,
      });
      for (var i = 1; i < payload.shopifyCartItems.length; i++) {
        var ci = payload.shopifyCartItems[i];
        items.push({
          id: ci.variantId,
          quantity: ci.quantity || 1,
          properties: { 'Added via': '3D Configurator', 'Desk': payload.name },
        });
      }
    }

    if (items.length === 0) return;

    // Remove old configurator items, then merge Controller Position into the
    // cart note, then add new
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      var updates = {};
      cart.items.forEach(function(item) {
        var p = item.properties || {};
        if (p['Configurator Slug'] || p['Added via'] === '3D Configurator') updates[item.key] = 0;
      });
      var note = buildCartNote(cart.note, deskProperties['Controller Position']);
      if (Object.keys(updates).length > 0 || note !== (cart.note || '')) {
        var body = { note: note };
        if (Object.keys(updates).length > 0) body.updates = updates;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
      }
    }).then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function(r) {
        return r.json().then(function(body) {
          if (!r.ok) {
            var err = new Error(body.description || body.message || 'Cart add failed');
            err.cartResponse = body;
            throw err;
          }
          return body;
        });
      });
    }).then(function() {
      iframe.contentWindow.postMessage(
        { type: 'shopify:cart-added', payload: { success: true, itemCount: items.length } },
        CONFIGURATOR_URL
      );
      // Don't redirect — let configurator show Continue/View Cart buttons
    }).catch(function(err) {
      console.error('[PelicanWork] Cart error:', err);
      alert('Failed to add to cart. Please try again.');
    });
  }

  // Bind all configure buttons with better handling for dynamic content
  function bindConfigureButtons() {
    document.querySelectorAll('.pw-configure-btn').forEach(function(btn) {
      if (!btn.dataset.bound) {
        btn.addEventListener('click', function() {
          var slug = btn.getAttribute('data-slug') || 'model-207';
          open(slug);
        });
        btn.dataset.bound = 'true';
      }
    });
  }

  // Try immediately and on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindConfigureButtons);
  } else {
    bindConfigureButtons();
  }

  // Also watch for dynamically added buttons (variant changes)
  if (window.MutationObserver) {
    new MutationObserver(bindConfigureButtons).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();
